import cBillingSummary from '#themes/default/default/components/billingSummary/billingSummary.js';
import cPriceTable from '#themes/default/default/components/priceTable/priceTable.js';
import cProduct from '#themes/default/default/components/product/product.js';

import template from './sidebar.html' with { type: 'html' };

export default {
	name: 'CSidebar',
	components: {
		cBillingSummary,
		cPriceTable,
		cProduct
	},
	props: {
		customer: {
			type: Object,
			default: () => null
		},
		form: {
			type: Object,
			default: () => null
		},
		isCompany: {
			type: Boolean,
			default: false
		},
		isCompanyDetailsPage: {
			type: Boolean,
			default: false
		},
		isEmpty: {
			type: Boolean,
			default: true
		},
		isLoading: {
			type: Boolean,
			default: false
		},
		isNewMethod: {
			type: Boolean,
			default: false
		},
		isShoppingCartPage: {
			type: Boolean,
			default: false
		},
		order: {
			type: Object,
			default: () => null
		},
		page: {
			type: Object,
			default: () => null
		},
		payment: {
			type: Object,
			default: () => null
		},
		providerAccount: {
			type: Object,
			default: () => null
		},
		selectedPayment: {
			type: Object,
			default: () => {}
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		},
		utils: {
			type: Object,
			default: () => null
		}
	},
	methods: {
		onRemoveProduct({ productId }) {
			this.tracking.removeFromCart({
				order: this.order,
				url: this.url
			}, this.$store.getters.getProduct(productId));
		},
		onAddProduct({ productId }) {
			this.tracking.addToCart({
				order: this.order,
				url: this.url
			}, this.$store.getters.getProduct(productId));
		}
	},
	template
};
